/* One loading cover for the big pages (Pre-production, the live board, project settings).
 *
 * Opening one of them used to show it assembling itself: an empty header, then
 * buttons, rows and side panels arriving one by one. This covers the page from its
 * first paint with a plain progress bar, and lifts the moment the page says it's
 * ready (PPCover.ready()) and has stopped changing. No minimum time: a page that's
 * ready at once shows at once. A page that never says so is uncovered anyway
 * after a few seconds, so nothing can stay hidden behind it.
 *
 * Load it as an ordinary <script> at the top of <head>, before anything paints.
 * The page it's on decides whether to cover (data-cover="if-settings": only on a
 * project's settings address, for the app's own index.html).
 */
(function () {
  'use strict';
  var me = document.currentScript;
  if (window.PPCover) return;
  var path = location.pathname;
  var only = me && me.getAttribute('data-cover');
  var off = /[?&]embed=1(?:&|$)/.test(location.search) ||
    (only === 'if-settings' && !/^\/(?:p\/[^/]+|(?!account\/|admin\/|team\/|help\/|my\/|jobs\/|crew\/)[^/]+)\/settings(?:\/|$)/.test(path));
  if (off) { window.PPCover = { ready: function () {}, lift: function () {}, covering: false }; return; }

  var MAX_MS = 6000;     // never hide a page longer than this
  var QUIET_MS = 120;    // ready, and nothing has changed on the page for this long
  var SETTLE_MAX = 900;  // ...but stop waiting for quiet after this
  var theme = 'dark';
  try { var t = localStorage.getItem('pp-theme'); theme = t === 'light' || t === 'dark' ? t : (matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'); } catch (e) {}

  var css = '#ppCover{position:fixed;inset:0;z-index:100001;display:grid;place-items:center;background:' + (theme === 'light' ? '#f4f4f4' : '#151a1d') + ';transition:opacity .14s ease-out}' +
    '#ppCover.pp-cover--off{opacity:0;pointer-events:none}' +
    '#ppCover .pp-cover__track{width:min(220px,60vw);height:4px;border-radius:2px;overflow:hidden;background:' + (theme === 'light' ? 'rgba(0,0,0,.1)' : 'rgba(255,255,255,.1)') + '}' +
    '#ppCover .pp-cover__bar{height:100%;width:100%;border-radius:2px;background:#34a9f7;transform-origin:left;transform:scaleX(.08);transition:transform 4s cubic-bezier(.1,.7,.3,1)}' +
    '#ppCover.pp-cover--go .pp-cover__bar{transform:scaleX(.88)}' +
    '#ppCover.pp-cover--done .pp-cover__bar{transform:scaleX(1);transition-duration:.12s}' +
    '@media (prefers-reduced-motion:reduce){#ppCover,#ppCover .pp-cover__bar{transition:none}}';
  var style = document.createElement('style');
  style.id = 'ppCoverStyle';
  style.textContent = css;
  var cover = document.createElement('div');
  cover.id = 'ppCover';
  cover.setAttribute('role', 'progressbar');
  cover.setAttribute('aria-label', 'Loading');
  cover.innerHTML = '<div class="pp-cover__track"><div class="pp-cover__bar"></div></div>';
  (document.head || document.documentElement).appendChild(style);
  document.documentElement.appendChild(cover);
  document.documentElement.setAttribute('aria-busy', 'true');
  // Start the bar on the next frame, so it eases from its first width.
  requestAnimationFrame(function () { requestAnimationFrame(function () { cover.classList.add('pp-cover--go'); }); });

  var gone = false, readyAt = 0, quietTimer = 0, watcher = null;
  function lift() {
    if (gone) return;
    gone = true;
    window.PPCover.liftedAt = Date.now();
    clearTimeout(quietTimer);
    if (watcher) watcher.disconnect();
    document.documentElement.removeAttribute('aria-busy');
    cover.classList.add('pp-cover--done', 'pp-cover--off');
    window.PPCover.covering = false;
    setTimeout(function () { if (cover.parentNode) cover.parentNode.removeChild(cover); if (style.parentNode) style.parentNode.removeChild(style); }, 200);
  }
  function quietSoon() {
    clearTimeout(quietTimer);
    var left = SETTLE_MAX - (Date.now() - readyAt);
    quietTimer = setTimeout(lift, Math.max(0, Math.min(QUIET_MS, left)));
  }
  function ready() {
    if (gone || readyAt) return;
    readyAt = window.PPCover.readyAt = Date.now();
    // Whatever the page draws right after it's ready (a panel, a count) lands under the cover.
    if (window.MutationObserver && document.body) {
      watcher = new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) if (list[i].target !== cover && !cover.contains(list[i].target)) { quietSoon(); return; }
      });
      watcher.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    quietSoon();
  }
  window.PPCover = { ready: ready, lift: lift, covering: true };
  // Pre-production holds its own sign-in gate (#authGate, storyboard.js) until it has started: ready when that goes.
  document.addEventListener('DOMContentLoaded', function () {
    var gate = document.getElementById('authGate');
    if (!gate || !window.MutationObserver) return;
    var seen = new MutationObserver(function () { if (!gate.isConnected) { seen.disconnect(); ready(); } });
    seen.observe(gate.parentNode, { childList: true });
  });
  setTimeout(lift, MAX_MS);
  // Back to a page the browser kept: it's already drawn.
  window.addEventListener('pageshow', function (e) { if (e.persisted) lift(); });
})();
